import React, { useState, useEffect } from 'react';
import EntitiesCard from '../EntitiesCard/EntitiesCard';
import OperationsCard from '../OperationsCard/OperationsCard';
import Cardheader from '../CheckBoxList/Header';
import CheckBoxList from '../CheckBoxList/CheckList';
import { useSelector } from 'react-redux';
import QueryString from './QueryString';
import CalendarComponent from '../../components/Calendar/Calendar';
import { pushSelectedCheckList, pushSelectedChipArray } from '../../slices/customQueryBodySlice';
import { useDispatch } from 'react-redux';
import ScoreComponent from './ScoreComponent';
import TypeComponent from './TypeComponent';
import { CardContainer, CardComponent, CardEntities, CardBody, ActionsCard, CardContentList, InputTextField, CardOperations } from './CustomStyle';
import Spinner from '@material-ui/core/CircularProgress';
import customQueryStyles from '../CustomQuery/CustomQueryStyle';

const CustomQueryBody = () => {
  const queryStringArray = useSelector(state => state.customQueryBody.queryStringArray);
  const selectedEntity = useSelector(state => state.customQueryHeader.selectedDataType);
  const searchLoader = useSelector(state => state.customQueryBody.searchLoader);
  const showCalendar = useSelector(state => state.customQueryBody.showCalendar);
  const dispatch = useDispatch();
  const [inputText, setInputText] = useState('');
  let entityName = selectedEntity.substring(0, selectedEntity.length - 1);

  const onChangeTextInput = event => {
    var value = event.target.value;
    setInputText(value);
  };

  useEffect(() => {
    if (queryStringArray.length > 0) {
      if (inputText) {
        let chipArray = [];
        chipArray.push(queryStringArray[0] + ' ' + queryStringArray[1] + ' ' + inputText);
        dispatch(pushSelectedCheckList(inputText));
        dispatch(pushSelectedChipArray(chipArray));
      } else {
        dispatch(pushSelectedCheckList(inputText));
        dispatch(pushSelectedChipArray([]));
      }
    }
  }, [inputText]);
  return /*#__PURE__*/React.createElement(CardContainer, null, /*#__PURE__*/React.createElement(QueryString, null), /*#__PURE__*/React.createElement(CardComponent, null, /*#__PURE__*/React.createElement(CardEntities, {
    className: "border-none"
  }, /*#__PURE__*/React.createElement(EntitiesCard, null)), /*#__PURE__*/React.createElement(CardOperations, {
    className: "opr-card"
  }, queryStringArray[0].length > 0 ? /*#__PURE__*/React.createElement(OperationsCard, {
    setInputText: setInputText
  }) : null), /*#__PURE__*/React.createElement(CardBody, null, queryStringArray.length >= 2 ? /*#__PURE__*/React.createElement(ActionsCard, {
    className: showCalendar ? 'rct-calendar' : ''
  }, !showCalendar && /*#__PURE__*/React.createElement(React.Fragment, null, queryStringArray[0] !== entityName + ' Risk Type' && queryStringArray[0] !== entityName + ' Risk Score' && queryStringArray[1] === 'is' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Cardheader, null), searchLoader ? /*#__PURE__*/React.createElement(Spinner, {
    animation: "border",
    role: "status",
    style: customQueryStyles.spinnerStyle
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardContentList, null, /*#__PURE__*/React.createElement(CheckBoxList, null)))) : queryStringArray[0] !== entityName + ' Risk Type' && queryStringArray[0] !== entityName + ' Risk Score' && queryStringArray[1] !== 'is' ? /*#__PURE__*/React.createElement(InputTextField, {
    type: "text",
    value: inputText,
    placeholder: "Enter Value",
    onChange: onChangeTextInput,
    variant: "outlined"
  }) : queryStringArray[0] === entityName + ' Risk Type' && queryStringArray[1] === 'is' ? /*#__PURE__*/React.createElement(TypeComponent, null) : queryStringArray[0] === entityName + ' Risk Score' && queryStringArray[1] === 'is' ? /*#__PURE__*/React.createElement(ScoreComponent, null) : null), showCalendar ? /*#__PURE__*/React.createElement(CardContentList, null, /*#__PURE__*/React.createElement(CalendarComponent, null)) : null) : null)));
};

export default CustomQueryBody;